<template>
	<div>
		<div class="wrapper-time">
			<div class="wrapper-text">
				<div v-for="(hour, indexHour) in hours" :key="indexHour">
					{{hour}}
				</div>
				<span>:</span>
			</div>
			<div class="wrapper-text">
				<div v-for="(minute, indexMinute) in minutes" :key="indexMinute">
					{{minute}}
				</div>
				<span>:</span>
			</div>
			<div class="wrapper-text">
				<div v-for="(second, indexSecond) in seconds" :key="indexSecond">
					{{second}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';

function hours() {
	return [...this.diffHours.toString()];
}

function minutes() {
	return [...this.diffMinutes.toString()];
}

function seconds() {
	return [...this.diffSeconds.toString()];
}

function created() {
	const fiveHours = (5 * 3600000);
	const endDateMiliseconds = new Date(this.endDate).getTime() - fiveHours;
	setInterval(() => {
		this.todayMiliseconds = new Date().getTime();
		this.diffHours = differenceInHours(endDateMiliseconds, this.todayMiliseconds);
		const diffMinutes = differenceInMinutes(endDateMiliseconds, this.todayMiliseconds);
		this.diffMinutes = (((diffMinutes / 60) - this.diffHours) * 60).toFixed(0);
		this.diffMinutes = this.diffMinutes.toString().length === 1
			? `0${this.diffMinutes}`
			: this.diffMinutes;
		const diffSeconds = differenceInSeconds(endDateMiliseconds, this.todayMiliseconds);
		this.diffSeconds = Math.abs(
			(((((diffSeconds / 3600) - this.diffHours) * 60) - this.diffMinutes) * 60).toFixed(0),
		);
		this.diffSeconds = this.diffSeconds.toString().length === 1
			? `0${this.diffSeconds}`
			: this.diffSeconds;
	}, 1000);
}

function data() {
	return {
		diffHours: 0,
		diffMinutes: 0,
		diffSeconds: 0,
		todayMiliseconds: 0,
	};
}

export default {
	name: 'time-maintance',
	data,
	computed: {
		hours,
		minutes,
		seconds,
	},
	created,
	props: {
		endDate: {
			default: '',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
.wrapper-time {
	display: flex;

	@media (max-width: 830px) {
		justify-content: center;
	}
}

.wrapper-text {
	display: flex;
	font-size: size(large32);
}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/time-promotion.vue